const SET_MESSAGE = (state, payload) => { state.message = payload }
const RESET_MESSAGE = (state) => {
    state.message = {
        title: '',
        message: {
            typeMessage: '',
            messageBody: {
                number: '',
            },
        },
        sendDate: '',
        errorCount: 0,
        from: 'Janoo',
        to: '',
        ref: null,
        refId: null,
        placeId: 1
    }
}

const SET_CUSTOMER_USER_CREATED = (state, payload) => { state.customer_user_created = payload }
const RESET_CUSTOMER_USER_CREATED = (state) => {
    state.customer_user_created = {
        scheduled_msg_title: 'Associado: Novo usuário criado!',
        messageModel: `Olá *{0}*, \nSeus dados foram enviados para a instituição *{1}*.\n\nEnviaremos novidades da avaliação de seu cadastro!`
    }
}

const SET_CUSTOMER_ACTIVATED_AGENT = (state, payload) => { state.customer_activated_agent = payload }
const RESET_CUSTOMER_ACTIVATED_AGENT = (state) => {
    state.customer_activated_agent = {
        scheduled_msg_title: 'Associado aceito ao Agente: Cadastro ativado!',
        messageModel: `Parabéns *{0}*!!\n\nCadastro validado por: *{1}*`
    }
}

const SET_VENDOR_USER_CREATED = (state, payload) => { state.vendor_user_created = payload }
const RESET_VENDOR_USER_CREATED = (state) => {
    state.vendor_user_created = {
        scheduled_msg_title: 'Novo usuário ao Gestor: Novo usuário criado!',
        messageModel: `Olá equipe *{0}*!\n\nTemos um novo cadastro aguardando sua aprovação!\n*Nome:* {1}\n*Contato:* {2}`
    }
}

const SET_REQUEST_INSTITUTION = (state, payload) => { state.request_institution = payload }
const RESET_REQUEST_INSTITUTION = (state) => {
    state.request_institution = {
        scheduled_msg_title: 'Solicitação de cadastro à Instituição: Solicitação de Cadastro!',
        messageModel: `*Nova instituição para cadastro*: \n\nNome: *{0}*\nCNPJ: *{1}*\nEmail: *{2}*\nTelefone: *{3}*\nCidade: *{4}*`
    }
}

export default {
    SET_MESSAGE,
    RESET_MESSAGE,

    SET_CUSTOMER_USER_CREATED,
    RESET_CUSTOMER_USER_CREATED,

    SET_CUSTOMER_ACTIVATED_AGENT,
    RESET_CUSTOMER_ACTIVATED_AGENT,

    SET_VENDOR_USER_CREATED,
    RESET_VENDOR_USER_CREATED,

    SET_REQUEST_INSTITUTION,
    RESET_REQUEST_INSTITUTION,
}
